
import { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Users from '../../collections/users';
import Packages from '../../collections/packages';
import UserPackages from '../../collections/user_packages';
import UserPackage from '../../models/user_package';

const CreateUserPackage = (props) => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [packages, setPackages] = useState([]);
  const [formData, setFormData] = useState({
    user_id: '',
    package_id: '',
    beginning_date: dayjs(),
    financial_status: 'PENDING',
    status: 'ACTIVE',
    sending_invoice_status: 'PENDING',
    note: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    props.setPageTitle('Tạo gói dịch vụ mới');
    fetchUsers();
    fetchPackages();
  }, [props]);

  const fetchUsers = async () => {
    const usersList = new Users();
    await usersList.fetch(1, 100);
    setUsers(usersList.items);
  };

  const fetchPackages = async () => {
    const packagesList = new Packages();
    await packagesList.fetch({ per_page: 100 });
    setPackages(packagesList.items);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userPackage = new UserPackage(formData);
      if (await userPackage.save()) {
        navigate('/user-packages');
      }
    } catch (error) {
      console.error('Error creating user package:', error);
      // You might want to add error handling here
    }
    setLoading(false);
  };

  return (
    <Container sx={{ mt: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl>
            <Autocomplete
              options={users}
              getOptionLabel={(option) => option.name || ''}
              onChange={(event, newValue) => {
                setFormData(prev => ({ ...prev, user_id: newValue?.id || '' }));
              }}
              onInputChange={async (event, newInputValue) => {
                if (newInputValue) {
                  const usersList = new Users();
                  await usersList.fetch(1, 100, {}, newInputValue);
                  setUsers(usersList.items);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Khách hàng"
                  required
                />
              )}
            />
          </FormControl>

          <FormControl>
            <InputLabel>Gói dịch vụ *</InputLabel>
            <Select
              value={formData.package_id}
              label="Gói dịch vụ *"
              required
              onChange={(e) => setFormData(prev => ({ ...prev, package_id: e.target.value }))}
            >
              {packages.map((pkg) => (
                <MenuItem key={pkg.id} value={pkg.id}>
                  {pkg.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Ngày bắt đầu"
              value={formData.beginning_date}
              onChange={(newValue) => setFormData(prev => ({ ...prev, beginning_date: newValue }))}
              slotProps={{
                textField: {
                  required: true,
                  fullWidth: true
                }
              }}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>

          <FormControl>
            <InputLabel>Trạng thái thanh toán *</InputLabel>
            <Select
              value={formData.financial_status}
              label="Trạng thái thanh toán *"
              required
              onChange={(e) => setFormData(prev => ({ ...prev, financial_status: e.target.value }))}
            >
              <MenuItem value="PAID">Đã thanh toán</MenuItem>
              <MenuItem value="UNPAID">Chưa thanh toán</MenuItem>
              <MenuItem value="PENDING">Đang chờ</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Ghi chú"
            multiline
            rows={4}
            value={formData.note}
            onChange={(e) => setFormData(prev => ({ ...prev, note: e.target.value }))}
          />

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/user-packages')}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
            >
              Tạo mới
            </Button>
          </Box>
        </Box >
      </Paper >
    </Container >
  );
};

export default CreateUserPackage;
